export const ExternalLinks = {
  CONTACT_SUPPORT: process.env.SUPPORT_REQUEST_URL,
  ONBOARDING: process.env.ONBOARDING_URL,
}

export const BASE_API_URL = process.env.API_URL
